import React from 'react'
import { DatePicker as AntdDatePicker } from 'antd'
import styled from 'styled-components'
import dayjs from 'dayjs'

/**
 * @typedef {object} Props
 * @property {import('dayjs').Dayjs} props.scheduleDate
 * @property {function} props.setScheduleDate
 * @param {React.ComponentProps<typeof AntdDatePicker> & Props} props
 */
export function DatePicker(props) {
  function disabledDate(current) {
    return current && current < dayjs().startOf('day')
  }

  return (
    <StyledAntdDatePicker
      allowClear={false}
      className="ui selection dropdown compact pr3"
      format="MMM D, YYYY"
      defaultValue={props.scheduleDate}
      disabledDate={disabledDate}
      {...props}
      onChange={props.setScheduleDate}
    />
  )
}

/** @type {typeof AntdDatePicker} */
const StyledAntdDatePicker = styled(AntdDatePicker)`
  border: 1px solid rgba(88, 102, 126, 0.12);
  border-radius: 0.25rem;

  && .ant-picker-input > input {
    border: none;
    box-shadow: none;
    background: transparent;
  }

  && {
    vertical-align: middle;
  }

  &:hover {
    border-color: rgba(34, 36, 38, 0.35);
  }

  &:focus,
  &:active,
  &.ant-picker-focused {
    box-shadow: none;
    border-color: rgba(34, 36, 38, 0.35);
  }

  &&& {
    padding-top: 7px;
    padding-bottom: 7px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/DatePicker/index.js